import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FrontaxleFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 4C10.7 4 9.6 4.9 9.2 6.1H7.9V7.7H9.2C9.5 8.7 10.2 9.4 11.2 9.7V16.2H7.9V17.8H16.1V16.2H12.9V9.8C13.8 9.5 14.6 8.7 14.9 7.8H16.2V6.1H14.9C14.4 4.9 13.3 4 12 4ZM12 8.2C11.3 8.2 10.7 7.6 10.7 6.9C10.7 6.2 11.3 5.6 12 5.6C12.7 5.6 13.3 6.2 13.3 6.9C13.3 7.6 12.7 8.2 12 8.2ZM4 9.8H6.9V4H4V9.8ZM17.1 4V9.8H20V4H17.1ZM4 20H6.9V14.2H4V20ZM17.1 20H20V14.2H17.1V20Z" />
    </SvgIcon>
  );
});
